import { types } from '../constants'

const index = {
  pending: `${types.listDestinationUrls}_PENDING`,
  fulfilled: `${types.listDestinationUrls}_FULFILLED`,
  rejected: `${types.listDestinationUrls}_REJECTED`
}

// Last request that started. A fulfilled/rejected action whose requestId
// is older leaves the catalog of the request still in flight untouched.
let activeCatalogRequestId: number | undefined

const isCurrentCatalogRequest = (action: { values?: { requestId?: number } }) =>
  action.values?.requestId == null ||
  action.values.requestId === activeCatalogRequestId

export const listDestinationUrls = {
  [index.pending]: ({ draft, action }) => {
    if (action.values?.requestId != null) {
      activeCatalogRequestId = action.values.requestId
    }
    draft.industry.publisherConfiguration.listDestinationUrls.loading = true
    draft.industry.publisherConfiguration.listDestinationUrls.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    if (!isCurrentCatalogRequest(action)) return

    draft.industry.publisherConfiguration.listDestinationUrls.data =
      action.payload

    draft.industry.publisherConfiguration.listDestinationUrls.loading = false
    draft.industry.publisherConfiguration.listDestinationUrls.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    if (!isCurrentCatalogRequest(action)) return

    draft.industry.publisherConfiguration.listDestinationUrls.loading = false
    draft.industry.publisherConfiguration.listDestinationUrls.error =
      action.payload
  }
}
